export default {
  setJobTitlesList (state, payload) {
    state.jobTitlesList = payload
  }
}
